export default "__VITE_ASSET__Drf1lk4N__"